export default [
    { //退货审核进度页面
        path: '/order/refundReviewProgress',
        name: 'refundReviewProgress',
        component: () => import('@/views/returnGoods/RefundReviewProgress.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
    { //申请售后页面
        path: '/order/afterSalesServiceList',
        name: 'afterSalesServiceList',
        component: () => import('@/views/returnGoods/AfterSalesServiceList.vue'),
        meta: {
            showTab: false,
            keepAlive: true
        }
    },
    { //选取退货方式页面
        path: '/order/returnedGoods',
        name: 'ReturnedGoods',
        component: () => import('@/views/returnGoods/ReturnGood.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
    { //退货快递选择
        path: '/order/refundGoodsLogistics',
        name: 'RefundGoodsLogistics',
        component: () => import('@/views/returnGoods/RefundGoodsLogistics.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
    {  //申请退货 界面
        path: '/order/applyRefund',
        name: 'ApplyRefund',
        component: () => import('@/views/returnGoods/ApplyRefund.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
    { //申请记录详情
        path: '/order/refundGoodsDetail',
        name: 'RefundGoodsDetail',
        component: () => import('@/views/returnGoods/RefundGoodsDetail.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
]
